export default "__VITE_PUBLIC_ASSET__da83ec31__"